<template>
  <div
    :is="activeDom"
    :subjectList="subjectList"
    :courseList="courseList"
    :mobileCourseList="mobileCourseList"
    :total="total"
    :params="params"
    :loading="loading"
    @changeKey="changeKey"
    @changeClassify="changeClassify"
    @changePageNum="changePageNum"
  ></div>
</template>
<script>
import { getSubjectList, getCourseList } from "@/api/api";
import mobile from "../components/courses/mobile.vue";
import pc from "../components/courses/pc.vue";
export default {
  name: "courses",
  components: {
    mobile,
    pc,
  },
  data() {
    return {
      activeDom: null,
      subjectList: [],
      courseList: [],
      mobileCourseList: [],
      total: 0,
      params: {
        key: "",
        ps: 20,
        pn: 1,
        classifyId: 0,
        parentId: 0,
      },
      time: 0,
      loading: true
    };
  },
  created() {
    getSubjectList().then((res) => {
      if (res.courseEducationOneId && res.courseEducationTwoId) {
        this.params.classifyId = res.courseEducationTwoId;
        this.params.parentId = res.courseEducationOneId;
        this.subjectList.push({
          classifyId: res.courseEducationOneId,
          name: "全部",
        });
        this.subjectList = this.subjectList.concat(res.classifies);
        this.getCourses();
      }
    });
    this.changeDom();
    window.addEventListener("resize", this.changeDom, false);
  },
  methods: {
    getCourses() {
      this.loading = true;
      this.time = new Date().getTime();
      const curTime = this.time;
      getCourseList(this.params)
        .then((res) => {
          if (this.time === curTime) {
            if (res && res.result && res.result.list) {
              this.courseList = res.result.list;
              this.total = res.result.total;
            } else {
              this.courseList = [];
              this.total = 0;
            }
            this.mobileCourseList = this.mobileCourseList.concat(this.courseList)
            console.log('数量' + this.params.pn, this.mobileCourseList.length)
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changeKey(val) {
      this.params.key = val;
      this.mobileCourseList = [];
      this.changePageNum(1)
    },
    changeClassify(classifyId) {
      this.params.parentId = classifyId;
      this.mobileCourseList = [];
      this.changePageNum(1)
    },
    changePageNum(val) {
      this.params.pn = val;
      this.getCourses();
    },
    changeDom() {
      this.activeDom = document.body.clientWidth > 767 ? pc : mobile;
      this.mobileCourseList = document.body.clientWidth > 767 ? this.courseList : this.mobileCourseList;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.changeDom);
  },
};
</script>